import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  dropdownButton: {
    fontWeight: 700,
    width: '10rem',
  },
  dropdownOpenedBtn: {
    backgroundColor: 'transparent',
    color: colors.blue[600],
    border: 'none',
    boxShadow: 'none',
    width: '10rem',
  },
  dropdownOption: { padding: '1.6rem' },
  deleteOption: {
    '&:hover': {
      backgroundColor: colors.red[100],
    },
    '&:active': {
      backgroundColor: colors.red[600],
      '& button': {
        color: colors.neutral.black,
      },
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
